import OSS from "ali-oss";

const client = new OSS({
  region: "oss-cn-shanghai",
  accessKeyId: "LTAI4GKXxgDWjEHU7zJwh9wX",
  accessKeySecret: "fapho01BAVnTCoUxWyx9IQ2p0lQyDg",
  // bucket: 'lation-ht-photos',
  bucket: "lation-platform",
  endpoint: "oss-cn-shanghai.aliyuncs.com"
});

// 测试 ali oss
window.ossTest = () => {
  let signUrl = aliOssTest("user/images/admin/admin_20210306175734323.jpg");

  let imgDom = document.createElement("img");
  imgDom.src = signUrl;
  document.getElementById("app").appendChild(imgDom);
};

// 依据oss图片地址返回图片防盗链地址
function aliOssTest(ossInImg) {
  // 图片名字，过期时间1分钟, 图片处理式样"style/jpg"
  let signUrl = client.signatureUrl(ossInImg, { expires: 6000 });
  signUrl = decodeURIComponent(signUrl);
  return signUrl;
}

// 上传文件至oss
async function uploadToAlioss(file, url) {
  try {
    const result = await client.put(url, file[0]);
    return result;
  } catch (error) {
    return null;
  }
}

export const accessUrl =
  "https://yangzi-manage.oss-cn-shanghai.aliyuncs.com/mall/static/assets/";

export default {
  install: function(Vue) {
    Vue.prototype.$aliOssTest = ossInImg => aliOssTest(ossInImg);
    Vue.prototype.$uploadToAlioss = (file, url) => uploadToAlioss(file, url);
    Vue.prototype.$accessUrl = accessUrl;
  }
};



// WEBPACK FOOTER //
// ./src/util/aliOss.js